import { ref, onMounted } from 'vue'

export function useAccessibility() {
  const isMonochrome = ref(false)
  const fontSizeMultiplier = ref(1) // 1 = 100% (normal)
  const brightnessLevel = ref(1) // 1 = 100%

  // Her qadam 4px qo'shadi (16px ning choragi, ya'ni 25% = 0.25)
  const SIZES = [
    { label: 'A-', value: 0.75, name: 'Kichik (-4px)' },
    { label: 'A', value: 1.0, name: 'Normal (0)' },
    { label: 'A+', value: 1.25, name: 'Katta (+4px)' },
    { label: 'A++', value: 1.5, name: 'Juda katta (+8px)' },
  ]

  const BRIGHTNESS_LEVELS = [
    { label: 'Past', value: 0.75 },
    { label: 'Normal', value: 1.0 },
    { label: 'Baland', value: 1.25 }
  ]

  const applyFilters = () => {
    let filterString = ''
    if (isMonochrome.value) {
      filterString += 'grayscale(100%) '
    }
    if (brightnessLevel.value !== 1) {
      filterString += `brightness(${brightnessLevel.value * 100}%) `
    }
    
    document.documentElement.style.filter = filterString.trim()
  }

  const applyFontSize = (val: number) => {
    document.documentElement.style.fontSize = `${val * 100}%`
  }

  const setMonochrome = (val: boolean) => {
    isMonochrome.value = val
    localStorage.setItem('a11y-monochrome', val ? 'true' : 'false')
    applyFilters()
  }

  const setFontSize = (val: number) => {
    fontSizeMultiplier.value = val
    localStorage.setItem('a11y-font-size', val.toString())
    applyFontSize(val)
  }

  const setBrightness = (val: number) => {
    brightnessLevel.value = val
    localStorage.setItem('a11y-brightness', val.toString())
    applyFilters()
  }

  onMounted(() => {
    const savedMonochrome = localStorage.getItem('a11y-monochrome')
    if (savedMonochrome === 'true') {
      isMonochrome.value = true
    }

    const savedBrightness = localStorage.getItem('a11y-brightness')
    if (savedBrightness) {
      const parsedB = parseFloat(savedBrightness)
      if (!isNaN(parsedB)) {
        brightnessLevel.value = parsedB
      }
    }
    
    applyFilters()

    const savedFontSize = localStorage.getItem('a11y-font-size')
    if (savedFontSize) {
      const parsed = parseFloat(savedFontSize)
      if (!isNaN(parsed)) {
        fontSizeMultiplier.value = parsed
        applyFontSize(parsed)
      }
    }
  })

  return {
    isMonochrome,
    fontSizeMultiplier,
    brightnessLevel,
    SIZES,
    BRIGHTNESS_LEVELS,
    setMonochrome,
    setFontSize,
    setBrightness
  }
}
